// App.vue

<template>
    <div id="app">
        <Header :username="user.name" :usermail="user.mail"></Header>
        <div id="contentContainer" :style="{paddingBottom: isNoPaddingBottom ? '0' : '150px'}">
            <div id="contentWrapper">
                <transition
                    name="fade"
                    mode="out-in">
                    <router-view/>
                </transition>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";

export default {
    components: {
        Footer,
        Header,
        //  Footer
    },
    data: function () {
        return {
            user: {
                name: 'Tony Stark',
                mail: 'tony.stark@ems.ad-alliance.de'
            },
        }
    },
    methods: {
        getParameterByName(name, url) {
            if (!url) url = window.location.href;
            // eslint-disable-next-line no-useless-escape
            name = name.replace(/[\[\]]/g, '\\$&');
            var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }
    },
    computed: {
        isTrackinglist: function () {
            return this.$route.path.indexOf('trackinglist') !== -1;
        },
        isNoPaddingBottom() {
            return this.$route.name === 'trackinglist' ||
                this.$route.name === 'showDashboard' ||
                this.$route.name === 'showReporting';
        }
    },
    mounted() {
        if (this.getParameterByName('session')) {
            // eslint-disable-next-line no-undef
            sso.saveSsoUser();
            location.href = '/';
        }
        // eslint-disable-next-line no-undef
        let user = sso.getSsoUser();
        if (user) {
            this.user.mail = user.mail;
            this.user.name = user.forename + ' ' + user.lastname;
        }
    },
    watch: {
        $route() {
            if (this.getParameterByName('session')) {
                // eslint-disable-next-line no-undef
                sso.saveSsoUser();
            }
        }
    }
}

</script>

<style lang="scss">
@import '~vuejs-noty/dist/vuejs-noty.css';
@import "assets/styles/icons.css";
@import "assets/styles/tooltip.css";

* {
    box-sizing: border-box;
    font-family: "Roboto", sans-serif;
}

body {
    margin: 0;
    background: $bodyBackground;
    color: $darkGrey
}

h2 {
    margin-top: 5px;
}

.bottom-bar {
    cursor: pointer;
    width: 100%;
    height: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
}

.bottom-bar:hover {
    background-color: $pink;
}

#app {
    position: relative;
    min-height: 100vh;
    bottom: 0;
}

#contentWrapper {
    width: 100%;
}

.accordion-item-trigger-icon {
    $size: 13px;
    display: block;
    position: absolute;
    top: 0;
    right: 1.25rem;
    bottom: 0;
    width: $size;
    height: $size;
    border-right: 2px solid #363636;
    border-bottom: 2px solid #363636;
    transform: translateY(calc(#{-$size} / 4)) rotate(45deg);
    transition: transform 0.2s ease;
}

.accordion-item-trigger-icon.is-active {
    transform: translateY(2px) rotate(225deg) !important;
}

#contentContainer {
    padding: 1em;
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 70px - 150px);
}

.center {
    height: 100%;
    display: flex;
    align-items: center;
}

.margin-right {
    margin-right: 15px;
}

.margin-right.icon {
    font-size: 1.3em;
}

.hover-highlight:hover {
    color: $pink;
}

h1 {
    color: $darkGrey;
    margin-block-start: 0.2em;
}

@media screen and (min-width: 1025px) {
    #contentContainer {
        width: 85%;
        max-width: 1400px;
        margin: auto;
    }
}

.v-spinner .v-dot2 {
    animation-name: colorChange !important;
}

.v-spinner .v-dot3 {
    animation-name: colorChange !important;
}

@keyframes colorChange {
    0%,
    100% {
        background-color: #00b6ed;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    50% {

        background-color: #da2567;
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
    }

    30% {
        background-color: #752b77
    }
}

@-webkit-keyframes colorChange {
    0%,
    100% {
        background-color: #00b6ed;
        -webkit-transform: scale(0);
        transform: scale(0);
    }
    50% {

        background-color: #da2567;
        -webkit-transform: scale(1.0);
        transform: scale(1.0);
    }

    30% {
        background-color: #752b77
    }
}

.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.3s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
    opacity: 0
}

.dot-flashing {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: rgba(0, 182, 237, 0.80);
    color: rgba(0, 182, 237, 0.80);
    animation: dot-flashing 1s infinite linear alternate;
    animation-delay: 0.5s;
}

.dot-flashing::before, .dot-flashing::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
}

.dot-flashing::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: rgba(0, 182, 237, 0.80);
    color: rgba(0, 182, 237, 0.80);
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 0s;
}

.dot-flashing::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: rgba(0, 182, 237, 0.80);
    color: rgba(0, 182, 237, 0.80);
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 1s;
}

@keyframes dot-flashing {
    0% {
        background-color: rgba(0, 182, 237, 0.80);
    }
    50%, 100% {
        background-color: rgba(0, 182, 237, 0.2);
    }
}

@media (min-width: 768px) and (max-width: 1024px) {
    #contentContainer {
        padding: 0 !important;
    }
}

@media only screen and (max-width: 768px) {
    #contentContainer {
        padding-top: 0;
        padding-bottom: 0 !important;
    }
}
</style>